import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments';
import { Observable, of } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

import { RecaptchaVersions } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class RecaptchaService {
  private readonly _apiHost = environment.apiHost;

  private _http = inject(HttpClient);
  private _recaptchaV3Service = inject(ReCaptchaV3Service);

  getToken(): Observable<string> {
    return environment.useRecaptcha ? this._recaptchaV3Service.execute('importantAction') : of('');
  }

  loadSiteKeyV2(): Observable<{ siteKey: string }> {
    return this._http.get<{ siteKey: string }>(
      `${this._apiHost}/recaptcha/${RecaptchaVersions.V2}/site-key/`,
    );
  }

  verifyRecaptcha(token: string, version: RecaptchaVersions): Observable<void> {
    return environment.useRecaptcha
      ? this._http.post<void>(`${this._apiHost}/recaptcha/${version}/verify-recaptcha/`, { token })
      : of(null);
  }
}
